module.exports = __webpack_public_path__ + "static/media/ellab.8af16771.png";